// One gate for production Chipless stats.
//
// Every RTDB stats counter write in analytics.js (daily_analytics/* and
// all_time_stats/*, including total_hands_dealt and the local
// chipless_total_hands_dealt cache written after that increment) plus PostHog
// init only run when this returns true. The live counter value is never
// rewritten here.
//
// All three must hold:
//   1. hostname is playchipless.com or www.playchipless.com
//   2. URL has no ?test=1
//   3. no player name starts with "zz-test" (e2e / helpers use "zz-test-")

export const PRODUCTION_STATS_HOSTS = ['playchipless.com', 'www.playchipless.com'];
export const TEST_PLAYER_NAME_PREFIX = 'zz-test';

/**
 * @param {object} [options]
 * @param {string} [options.hostname]
 * @param {string} [options.search]
 * @param {Iterable<string>|null} [options.playerNames]
 * @returns {boolean}
 */
export function shouldCountStats({ hostname, search, playerNames } = {}) {
  const host =
    hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '');
  const query =
    search ?? (typeof window !== 'undefined' ? window.location.search : '');

  if (!PRODUCTION_STATS_HOSTS.includes(host)) {
    return false;
  }

  const raw = typeof query === 'string' && query.startsWith('?') ? query.slice(1) : String(query || '');
  if (new URLSearchParams(raw).get('test') === '1') {
    return false;
  }

  if (playerNames) {
    for (const name of playerNames) {
      if (typeof name === 'string' && name.startsWith(TEST_PLAYER_NAME_PREFIX)) {
        return false;
      }
    }
  }

  return true;
}

/**
 * Collect player names from a room players object or array.
 * @param {object|Array<{name?: string}>|null|undefined} players
 * @returns {string[]}
 */
export function playerNamesFrom(players) {
  if (!players) return [];
  const list = Array.isArray(players) ? players : Object.values(players);
  return list
    .map((player) => (player && typeof player.name === 'string' ? player.name : ''))
    .filter(Boolean);
}
